import React from 'react';

const TermsOfUse = () => {
  const textStyle = {
    direction: 'rtl', // Right-to-left text direction for Hebrew
    textAlign: 'right', // Align text to the right
    fontFamily: 'Arial, sans-serif', // Use a clean, readable font
    lineHeight: '1.6', // Improve readability with line spacing
    padding: '20px', // Add some padding for spacing
    backgroundColor: '#FAF7F0', // Background color to match your design
    color: '#4A4947', // Text color to match your design
    borderRadius: '10px', // Rounded corners
    margin: '20px', // Add margin for spacing around the component
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Add subtle shadow for depth
  };

  return (
    <div style={textStyle}>
      <h1>תנאי שימוש באתר "mariage"</h1>
      <p>
        ברוכים הבאים לאתר mariage אשר מספק שירותי אישורי הגעה, הזמנות דיגיטליות לאירועים
        (יחד להלן: "השירותים").
      </p>
      <p>
        בעל האתר ומפעילו הינו מריאז' חתונות (להלן: "האתר" ו/או "מפעיל/ת האתר" ו/או "מפעיל/ת
        השירות" ו/או "החברה").
      </p>
      <p>
        תנאי השימוש באתר מגדירים את היחסים בין האתר לבין כל גולש ו/או משתמש (להלן "הלקוח"
        ו/או "המשתמש"). השימוש באתר ובתכנים המוצגים בו מכל מכשיר שהוא כפוף לתנאי השימוש
        ומחייב את קריאת התקנון ומדיניות הפרטיות.
      </p>
      <p>
        כל שימוש באתר ובתכנים המוצגים בו, כולל העיון והגלישה בו, וכן כל פעולה בו, כולל רכישה
        באמצעותו, נכפים לתנאי השימוש המפורטים להלן. נא לקרוא בעיון ובקפידה את התנאים
        המפורטים. אין חובה להסכים לתנאים אלו, אך במקרה של אי הסכמה, משתמש נדרש לסיים את
        השימוש באתר מיד, ואסור עליו לבצע כל שימוש נוסף. התחלת השימוש באתר מהווה הסכמה ואישור
        לתנאים המפורטים כאמור.
      </p>
      <p>
        השימוש באתר מהווה את ההסכמה של המשתמש לכל תנאיו, ללא הגבלה או הסתייגות. בעת ביצוע
        שימוש באתר, המשתמש מתחייב שלא יגיעו ממנו, או מטעמו, טענות או תביעות בצורה ישירה או
        עקיפה, נגד האתר ו/או בעליו ו/או מפעיליו ו/או מנהליו ואו מי מטעמו.
      </p>
      <p>
        תנאי השימוש באתר משתמשים בלשון זכר לצורך נוחות בלבד, ומתכוונים לנשים וגברים כאחד.
      </p>
      <p>
        כותרות הפרקים מובאות לנוחות והתמצאות בתנאי השימוש ואינן מיועדות לשמש לצורך
        פרשנותו.
      </p>
      <p>
        האתר שומר לו את הזכות להציע, לשנות, ולהחליף מבצעים והטבות. כמו כן, האתר שומר לו את
        הזכות להפסיק את המבצעים וההטבות בכל עת וללא צורך בהודעה מוקדמת. לא תינתן האפשרות לכפל
        מבצעים למעט במקרים בהם יצוין אחרת על ידי מפעילת האתר.
      </p>
      <p>
        הגישה והשימוש באתר האינטרנט כולל שימוש בכל התכנים, המידע והשירותים המוצגים בו, הינם
        כפופים לתנאי השימוש המפורטים להלן ולהוראות כל דין החל במדינת ישראל.
      </p>
      <p>
        סרטוני הדרכה, תמונות והצגת השירותים מוצגים למטרות המחשה בלבד ואין להם תוקף של חוזה או
        התחייבות מכיוון מפעילת האתר.
      </p>
      <p>
        השימוש באתר ובתכנים שבו מיועד לשימוש פרטי ואינו מסחרי, למעט במקרים בהם נקבע אחרת על
        ידי מפעילת האתר. אסור להעתיק, לשכפל, להפיץ, למכור או להציג מוצרים באתר ללא רשות מראש
        ובכתב מצד מפעילת האתר.
      </p>
      <p>
        כל אדם או חברה המבצע/ת פעולה כלשהי באתר, לרבות אדם המבצע הרשמה לשירות לעיל ולהלן:
        ("הלקוח") מצהיר בעת ביצוע הפעולה כי קרא תנאי שימוש אלו, הבין אותן וכי הוא מסכים
        לתנאים ולהוראות.
      </p>
      <h1>תקנון</h1>
      <h2>1. כללי</h2>
      <p>
        1.1 משמעות התקנון - גלישה באתר ו/או כניסה אליו ו/או שימוש בשירותים המוצעים בו, מבטאת
        ומהווה הסכמה מצדך לתנאי תקנון זה ולאמור בו, והם יחולו על כל פעולה שביצעת ותבצע באתר.
        אם אינך מסכים לתנאי השימוש, כולם או חלקם, אינך רשאי לגלוש ו/או לעשות כל שימוש באתר לכל
        מטרה שהיא.
      </p>
      <p>
        1.2 כוחו הנורמטיבי של התקנון - בכל מקרה של סתירה בין התקנון לבין כל פרסום אחר, מכל סוג
        ומין, תגברנה הוראות תקנון זה, והן אשר תחייבנה את הגולש ביחסיו עם הנהלת האתר.
      </p>

      <h2>2. הגדרות</h2>
      <p>
        2.1 "גלישה באתר" - שימוש מכל סוג ומכל דרך קיימת ועתידית וביניהם באמצעות מחשב ו/או
        באמצעות טלפון סלולארי ו/או מכשירים אחרים. עצם השימוש באתר ותכניו כפוף לתנאים המפורטים
        בתקנון האתר, ועצם הכניסה מעיד כי הגולש קרא בעיון את התקנון והבין את המשמעויות הישירות
        והעקיפות שבו והביע הסכמתו ואישור לאמור בתקנון זה.
      </p>
      <p>
        2.2 "גולש" - כל אדם ו/או תאגיד ו/או גוף כלשהו, בין אם מדובר בלקוח ובין אם מדובר בבעל
        עסק, חברה ו/או כל הגדרה אחרת, המבצעים גלישה באתר כמוגדר לעיל.
      </p>
      <p>
        2.3 "מידע אישי/פרטים אישיים" - משמעו כל מידע מזהה של הגולש, לרבות שמו הפרטי ושם
        משפחתו, מספר הטלפון הנייח והנייד, כתובת מגורים, כתובת דואר אלקטרוני, כתובת מתחם אישי
        (Domain name) וכל מידע מזהה אחר אשר נמצא באתר ובכל האינטרנט.
      </p>

      <h2>3. הגבלות שימוש באתר</h2>
      <p>
        3.1 כל גולש מוזמן להשתמש באתר, כל עוד הוא מקבל על עצמו את תנאי תקנון זה. על גולשים
        מתחת לגיל 18 לקרוא את התנאים המיוחדים החלים לגבי קטינים בתקנון זה.
      </p>
      <p>
        3.2 הנהלת האתר רשאית למנוע השתתפותו של כל גולש בכל אמצעי העומד לרשותה, בחלק
        מהשירותים או בכולם, לתקופה קצובה ובלתי קצובה, בהתאם לשיקול דעתה הבלעדי ומכל סיבה
        שהיא, ללא חובה להסביר או לנמק החלטה זו. גולש אשר השתתפותו נמנעה כאמור, לא יהיה
        רשאי לשוב ולהשתתף תחת שם משתמש אחר בתקופת המניעה.
      </p>
      <p>
        3.3 אין לבצע כל שימוש מסחרי שאינו אישי באתר ובכלל זה נאסר על הגולש לפרסם את כתובת
        האתר בכל אתר אינטרנט או בכל פרסום מסחרי מכל סוג שהוא למטרת שימוש מסחרי, ללא רשות
        מפורשת בכתב של הנהלת האתר. ככל שברצונך לבצע באתר כל שימוש אחר, לרבות העלאת חומרים
        שיווקיים וכדומה יש לפנות להנהלת האתר.
      </p>
      <p>
        3.4 המשתמש מצהיר ומתחייב כי לא יעשה כל שימוש בשירות על מנת להפיץ כל תוכן פוגעני
        ו/או גזעני ו/או מטריד ו/או הפוגע בפרטיותו של אדם כלשהו ו/או כל תוכן הנוגד כל דין.
        האתר יהא רשאי על פי שיקול דעת והמלא והבלעדי להפסיק את השירות ו/או למנוע שימוש
        בשירות ו/או לחדול מלהעביר הודעות במסגרת השירות בכל מקרה של חשש לשימוש לרעה או
        במקרה של חשש להפרת הוראות הדין וזאת ללא כל הודעה מראש.
      </p>

      <h2>4. זכויות קנייניות</h2>
      <p>
        4.1 כל הזכויות באתר, לרבות זכויות הקניין הרוחני בשירותים הנלווים הינם של האתר בלבד.
      </p>
      <p>
        4.2 להסרת ספקות, האתר הינו הבעלים הבלעדי במאגרי הנתונים של האתר, התמונות, הטקסטים
        וכל חומר אחר הכלול בו. מובהר כי אין להעתיק, להפיץ, לשכפל, לשנות, לפרסם, לשדר,
        להעביר, למכור, להפיץ, ליצור יצירות נגזרות, להציג בפומבי, להעמיד לרשות הציבור או
        למסור לצד שלישי את המידע באתר ו/או כל חלק ממנו, לרבות עשיית שימוש מסחרי כלשהו
        במידע באתר, אלא בהיתר מראש ובכתב של הנהלת האתר. למרות זאת, החברה לא תהיה אחראית
        כלפי שום הגולש במקרה בו תעלה טענה או קביעה של פגיעה או הפרה כלשהי של זכויות קניין
        רוחני כלשהן בקשר עם רשות השימוש המוענקת לו באתר.
      </p>
      <p>
        4.3 יודגש כי האתר מאפשר לבעלי עסקים שונים המופיעים באתר, אפשרות גישה ישירה לאתר
        באופן שיוזנו נתונים באופן עצמאי על ידי אותם בעלי עסקים. הגם שלאתר אין ולא תהיה
        אחריות כלשהי לגבי אותם תכנים, אין בכך כדי לפגוע בזכויות הקניין של האתר בנוגע לכל
        מידע המופיע בו וזכויות השימוש באותו מידע.
      </p>
      <p>
        4.4 בעלי עסקים ו/או לקוחות ו/או כל גורם עסקי אחר מוגדר ביחסיו עם האתר ובין אם לאו,
        מכל סוג ומין שהוא, בין באם הזינו מידע באופן עצמאי לאתר ובין אם באמצעות האתר, לא
        יוכלו לטעון לזכויות קניין כלשהם ביחס לחומרים שיועלו לאתר והם מקנים זכויות אלו לאתר
        או מי מטעמו במלואן, כך שהאתר יוכל לעשות בהם כל שימוש שימצא לנכון וזאת אלא אם כן
        הגדירו זאת הצדדים אחרת בכתב.
      </p>
      <h2>4.5 הבעלות והשימוש במידע שנאסף באתר</h2>
      <p>
        4.5.1 האתר ו/או בעליו יהיו הבעלים הבלעדיים של כל מידע שנאסף באתר, לרבות היקף השימוש בו,
        זהות המשתמשים, אופן השימוש בו, ו/או כל מידע אחר הנוגע לגלישה באתר ומסד הנתונים
        שיצטבר ביחס לכך.
      </p>
      <p>
        4.5.2 מידע שנאסף מבעלי האירועים (משתמשי המערכת) עשוי להיות מועבר לצדדים שלישיים,
        לרבות ספקים חיצוניים, לצורך הצעות לשירותים נוספים, וזאת בכפוף להוראות הדין.
      </p>
      <p>
        4.5.3 מידע שנאסף מהאורחים (כגון שמות, מספרי טלפון ניידים, כתובות דוא"ל) ישמש אך ורק
        למטרות הנדרשות במסגרת המערכת ולא יועבר לגורמים צד שלישי, למעט אם יידרש על פי דין.
      </p>
      <p>
        4.5.4 עצם השימוש באתר מהווה הסכמה מצד המשתמשים לאיסוף ועיבוד המידע כפי שמתואר
        בתקנון זה.
      </p>
      <p>
        4.6 כל המפר תקנון זה ישפה את הנהלת האתר, עובדיו, מנהליו, בעלי מניותיו או מי מטעמם
        בגין כל נזק, הפסד, אבדן רווח, הוצאה לרבות שכר טרחת עורך דין והוצאות משפט שיגרמו
        כתוצאה מהפרה זו.
      </p>

      <h2>5. רישום לאתר ולשירותיו</h2>
      <p>
        5.1 אנו שואפים לספק לכם את המידע המוצג באתר ללא הפרעות אך יתכנו בשל שיקולים טכניים,
        תקלות צד ג' או אחרים, הפרעות בזמינות האתר. ולכן איננו יכולים להתחייב כי האתר יהיה
        זמין לכם בכל עת ולא יינתן כל פיצוי כספי או אחר בשל הפסקת פעילות האתר.
      </p>
      <p>
        5.2 קישורים לאתרים חיצוניים אינם מהווים ערובה כי מדובר באתרים בטוחים, איכותיים או
        אמינים וביקור בהם נעשה על דעתכם האישית בלבד ונמצאים בתחום האחריות הבלעדי של הגולש
        באתר.
      </p>
      <p>
        5.3 מובהר כי ככל שהפרטים שנמסרו על ידי הגולש אינם נכונים, האתר שומר לעצמו את הזכות,
        בהתאם לשיקול דעתו הבלעדי, למנוע מגולש גישה לאתר או לאסור עליו שימוש באתר ובשירותיו.
      </p>

      <h2>6. שימוש באתר על ידי קטינים (מתחת לגיל 18)</h2>
      <p>
        השימוש באתר מותר לקטין וזאת כל עוד לא מבוצעת על ידו פעולה האסורה על פי דין, אך השימוש
        לקטינים כפוף לאישור הוריהם או האפוטרופוס החוקי שלהם. עצם השימוש באתר, כמוהו כהצהרה
        שההורה ו/או האפוטרופוס אישר את שימוש הקטין באתר, לאחר שקרא בעיון את תנאי תקנון זה.
        כאשר קטין משתמש באתר, האתר פטור מכל אחריות בקשר לכך ולא תהיינה לו כל תביעות, טענות
        או דרישת כלפי האתר.
      </p>

      <h2>7. העדר אחריות האתר ו/או מי מטעמו</h2>
      <h3>7.1 כללי - העדר אחריות</h3>
      <p>
        7.1.1 הגולש מצהיר כי האתר אינו נושא באחריות והוא מוותר על כל תביעה, טענה ודרישה כנגד
        האתר ו/או הפועל מטעמה. הגולש פוטר ומשחרר את האתר ו/או מי מטעמו באופן מוחלט ובלתי
        חוזר מאחריות לכל סוג נזק, אי נוחות, אבדן מכל סוג, עוגמת נפש, הפסד, הוצאות, פיצוי
        נזיקי מכל סוג שהוא וכדומה, שנגרמו במישרין ובעקיפין לרכוש כל גולש שהוא או כל צד שלישי
        בשל שימוש בתכנים ובשרותי האתר (לרבות אם האתר לא מבצע את שירותיו במסגרת החבילה
        שנרכשה מכל סיבה שהיא).
      </p>
      <p>
        7.1.2 הגולש מצהיר כי אין האתר ובעליו אחראיים לתוכן ו/או לזמינות האתר או לזמינות
        אתרים מקושרים ובכל מכשיר קצה בו הם מופיעים, וכי הוא פוטר את האתר ו/או מי מטעמו
        מאחריות לפיצוי כלשהו בגין עיכובים, חוסר יכולת להשתמש באתר ובשירותיו ומחדירה בלתי
        מורשית למחשבים וכדומה, אף כאשר נודע לאתר על אפשרות של נזק פוטנציאלי או קיים.
      </p>
      <h2>7.1 כללי - העדר אחריות</h2>
      <p>
        7.1.3 הגולש מתחייב כי במידה ויפר זכויות על פי כל דין או הוראה מהוראות תקנון זה, האתר
        מסיר מעצמו אחריות והגולש יישא באחריות הבלעדית והמלאה לתביעה. בכלל האמור, הגולש יהיה
        אחראי כלפי האתר ביחס לכל תביעה ו/או הפרה שתוגש כנגדו ביחס לחומרים שיועלו באתר על ידי
        גולשים. אלו ישפו את החברה בגין כל תביעה שתוגש כנגדה לרבות הוצאות ושכ”ט עו”ד או כל
        הוצאה אחרת שתיגרם להנהלת האתר וכן בגין כל פגיעה בשמו הטוב ובמוניטין של האתר ו/או של
        מפעילו.
      </p>
      <p>
        7.1.4 האתר ו/או בעליו אינו אחראי לתגובות התכנים באתר או לשימוש שיעשו אחרים בתכני
        הגולשים כגון פגיעה בזכויות קניין רוחני.
      </p>
      <p>
        7.1.5 באתר זה עשוי לעשות שימוש בקבצי קוקיז (במיוחד עבור משתמשים רשומים ומנויים)
        ובממשקי סטטיסטיקה פנימיים בכדי לשמור תיעוד סטטיסטי אנונימי של גולשים וניתוח תנועת
        הגולשים, הרגלי גלישה באתר וניתוח קליקים וזמן שהייה.
      </p>

      <h2>7.2 העדר אחריות האתר לתכני צד ג’ והגולשים</h2>
      <p>
        7.2.1 האתר לא יישא בכל אחריות לתוכן והמידע שיפורסמו באתר. יובהר למען הסר ספק, כי האתר
        אינו מביע תמיכה, מעודד, מסכים או נותן חסות במפורש ו/או בכלל לתכנים ו/או לשירותים
        המוצעים על ידי אחרים. כמו כן, האתר אינו נותן חסות, מעודד, מציע, מסכים או מביע דעה
        לגבי נכונות ו/או דיוק ו/או רמת איכות התכנים של כל מידע, פרסומות, שירותים, מוצרים,
        דעות ועמדות המוצגים באתר מטעם הגולשים וצדדים שלישיים.
      </p>
      <p>
        7.2.2 כל הסתמכות המשתמש על כל תוכן, מידע, תמונות, פרסומות, מוצרים, סרטונים, דעות
        ועמדות המוצגים או המפורסמים באתר זה ובאתרים אליהם ישנה אפשרות הפניה, לרבות במידע,
        תוכן, דעות ועמדות המוצגים ומפורסמים שם, נעשה על פי שיקול דעתו הבלעדי של הגולש ועל
        אחריותו הבלעדית. האתר אינו אחראי לכל תוצאה שתיגרם מהשימוש באתר צד ג’ וההסתמכות
        עליו.
      </p>

      <h2>7.3 העדר אחריות האתר לעסקאות עם צד ג’ ובין קהילת הגולשים</h2>
      <p>
        7.3.1 האתר אינו צד לכל עסקה בין הגולשים לבין עצמם ו/או בין גולש ללקוח עסקי, והוא לא
        יישא באחריות לשירותים ולמוצרים שיוצעו באתר או באתרים אליהם הגיעו הגולשים באמצעות
        קישורים מהאתר ולרכישות שיבוצעו בעקבות כך. הגולש מוותר בזאת על כל תביעה מכל סוג
        שהוא כלפי הנהלת האתר בעניין זה.
      </p>

      <h2>8. תלונות בנוגע לתוכן</h2>
      <p>
        8.1 בכל סוגיה הנוגעות לתוכן ושימוש באתר, יש לפנות להנהלת האתר בעמוד "צור קשר" לצורך
        הגשת תלונה בנוגע לתכנים. יש לציין בפנייה קישור (לינק) למיקום המדויק בו מופיע התוכן
        האמור וכן לציין פרטים מדויקים ליצירת קשר.
      </p>
      <p>
        8.2 על אף שהאתר ישתדל לטפל בבעיה בהקדם האפשרי, הוא אינו מתחייב למועד גמר הטיפול.
        גם הפניית התלונה למעלה התכנים באתר שהנו צד שלישי תחשב כטיפול מלא ומקיף בתלונה.
      </p>
      <h2>9. הדין החל וסמכות שיפוט</h2>
      <p>
        9.1 על תקנון זה ועל כל הנובע ממנו או הכרוך בו, יחולו אך ורק דיני מדינת ישראל והוא יפורש
        על פיהם. מקום השיפוט הבלעדי לכל עניין הנוגע לתקנון זה או לשימוש באתר הינו בבתי המשפט
        המוסמכים בתל-אביב בלבד.
      </p>

      <h2>השירותים</h2>
      <p>
        11. באמצעות הפלטפורמה, הודעות אישורי הגעה יישלחו לאורחים המוזמנים לאירוע באמצעות
        ה-WhatsApp של מפעילת האתר ו/או SMS ו/או שיחות טלפון על ידי מוקד אנושי. מובהר כי השימוש
        באמצעים אלו מותר אך ורק למטרות אישורי הגעה, ואסור להשתמש בהם לצורך ספאם או שימושים
        אחרים. במקרה בו יעשה שימוש חורג כאמור על ידי המשתמש, הוא יהיה חייב בשיפוי החברה
        בעבור כל נזק שנגרם לה, בין במישרין ובין בעקיפין.
      </p>
      <p>
        בנוסף, החברה אינה אחראית למקרים של תקלות או מגבלות שמקורן בספקי צד שלישי, כגון WhatsApp
        או ספקי SMS חיצוניים. תקלות כגון ניסויים שיווקיים או טכנולוגיים, שינויים מערכתיים,
        חסימות יזומות מצד הספקים, מגבלות רגולטוריות או חסימות ספציפיות של מספרי טלפון מצד
        הנמען או הספק עלולות למנוע את מסירת ההודעות ליעדן. במקרים אלו, החברה לא תישא
        באחריות לאי-מסירת ההודעות, לעיכובים בהגעתן או לכל נזק ישיר או עקיף שנובע מכך.
      </p>
      <p>
        מובהר בזאת כי החברה עושה את מירב המאמצים לספק את שירותי ההודעות בצורה מלאה ומדויקת,
        אך במקרים של תקלות שמקורן בצד שלישי המשתמש מוותר בזאת על כל טענה או תביעה כנגד החברה
        בגין אי-הגעת הודעות או תקלות במשלוחן.
      </p>

      <p>
        12. שימוש בשירותי ההתקשרות לאורחי האירוע הינו למטרות אישורי הגעה והינו בהתאם לימים
        ושעות פעילות המוקד הטלפוני. כל שליחת הודעה מכל סוג בימי מנוחה, ערבי חג, ימי זיכרון
        וכיפור הינן על אחריותו הבלעדית של המשתמש.
      </p>

      <p>
        14. המשתמש באתר יכול לשתף ולקשר תכנים מהשירות באמצעות רשתות חברתיות שונות ושירותים
        של צדדים שלישיים, כמו פייסבוק ואינסטגרם. שימוש ברשתות חברתיות ושירותי צד ג' יתבצע על
        אחריות המשתמש בהתאם למדיניות של הרשתות ו/או הצדדים השלישיים, ואינו קשור למפעיל
        השירות.
      </p>

      <p>
        15. שליחת הודעות עצמאית תתבצע על ידי העתקת קישור ושליחתו באופן עצמאי דרך חשבון הווצאפ
        של המשתמש.
      </p>

      <p>
        16. שירות אישורי הגעה בתשלום ישולמו מראש על ידי המשתמש. כדי לקבל את השירות, יידרש
        המשתמש, בעל האירוע, להירשם באתר או באפליקציה ולמלא את הפרטים הנדרשים. כמו כן, נדרש
        לוודא את המועד הרצוי לקבלת השירות מצד החברה לפני זמן השירות. במקרים של שירותי שליחת
        הודעות וביצוע שיחות (כפי שהוגדרו להלן), החברה תתחיל לספק את השירות במועד שיקבע באופן
        אוטומטי, באמצעות הודעות או שיחות טלפוניות.
      </p>

      <p>
        17. שירות הגעה לאולם וסידורי הושבה מתאפשר בתשלום נוסף ובקשה מראש.
      </p>

      <p>
        18. נוסח ההודעות שישלחו למוזמנים באמצעות חשבון ה-WhatsApp של החברה יהיה קבוע מראש ולא
        יהיה ניתן לשינוי או עריכה על ידי המשתמש. בתוך נוסח המסרונים יוטמעו באופן אוטומטי פרטי
        האירוע כפי שהוזנו על ידי המשתמש. ייתכנו עיכובים בעת שליחת ההודעות, ככל שישנם עומסים
        על השרתים ו/או גורמים חיצוניים שעשויים להשפיע על תהליך שליחת ההודעות.
      </p>

      <p>
        19. החברה אינה אחראית אם פניה אינה מגיעה ליעדה או אם אין אפשרות לכל אדם לאשר או לעדכן
        את סטטוס הגעתו, מכל סיבה שהיא.
      </p>

      <p>
        20. המשתמש מסכים לאפשר לחברה להעביר לאולם האירוע ולכל מי מטעמו או נותן שירות אחר
        הקשור לאירוע, את מספר המוזמנים שאישרו את הגעתם לאירוע.
      </p>

      <p>
        21. בקישור האישי של המוזמן יופיע "שם האורח" בדיוק כפי ששמו מופיע ברשימת המוזמנים בעמוד
        אישורי הגעה. יש לוודא שהשמות הם שלמים (לדוגמה: "יוסי ואורית כהן") וללא כל תוספת כינוי
        (לדוגמה: "יוסי מזגנים" או "אורית שכנה"). החברה אינה אחראית במידה ושם האורח מופיע
        בתוספת כינוי מלבד שמו.
      </p>
      <p>
        קיימת למשתמש ("בעל האירוע") האפשרות לבטל את תצוגת "שם האורח" בהזמנה האישית דרך עמוד
        ההגדרות של האירוע.
      </p>

      <h2>22-27. הגדרות ושירותים</h2>
      <p>
        22. בשירות בו מתבצעת שליחה של הודעות ב-WhatsApp או ב-SMS על ידי המערכת, על המשתמש לספק
        את רשימת המוזמנים בהוספה ידנית על ידי מילוי פרטי המוזמן דרך המערכת.
      </p>
      <p>
        23. המשתמש נדרש לבדוק במערכת כי הרשימה שהועלתה למערכת היא תקינה ומעודכנת לשביעות
        רצונו.
      </p>
      <p>
        24. בעת רכישת חבילת הבסיס או כל חבילת אישורי הגעה אחרת (להלן "חבילות אישורי הגעה")
        המשתמש מקבל צבירה מוגבלת של אישורי הגעה והוספת מוזמנים בהתאם לחבילה שנרכשה. בעת חריגה,
        לא יהיה ניתן להוסיף עוד מוזמנים.
      </p>
      <p>
        25. בעת רכישה של כל אחת מהחבילות המערכת תקבע באופן אוטומטי את שלבי תהליך אישורי ההגעה
        ותציב מועד לביצוע כל פעולה בהתאם למועד האירוע כפי שהוזן במערכת על ידי הלקוח. ככל
        וידרש שינוי במועדי שליחת ההודעות או ביצוע השיחות יש לפנות לחברה. לחברה קיימת הזכות לא
        לבצע שינוי במועדי ביצוע השיחות בהתאם ללו"ז המוקד אך ייעשה מאמץ להיענות לבקשת זמני
        הלקוח.
      </p>
      <p>
        26. במצב של חריגה בכמות הרשומות של החבילה "פרימיום" תינתן האפשרות לשלם עבור הרשומות
        שחורגות מהחבילה בלבד לפי התעריף הבא: 2.5 ש"ח לרשומה. ניתן ליישם זאת בשיחה למוקד.
      </p>
      <p>
        27. במקרים מסוימים, שירות ההושבה עשוי להתבצע על ידי ספק חיצוני שאושר על ידינו.
        האחריות על מתן השירות היא של הספק החיצוני. במקרה של תלונות, יש לפנות אלינו ואנו נפעל
        כמיטב יכולתנו לפתור את הבעיה מול הספק החיצוני. לא נהיה אחראים לנזקים הנובעים מהשירות
        של הספק החיצוני, אלא במקרה של רשלנות חמורה או כוונה תחילה מצדנו.
      </p>

      <h2>מדיניות אספקת מוצרים</h2>
      <p>
        המוצרים והשירותים הנמכרים באתר הינם מוצרים דיגיטליים, ולכן אספקתם מתבצעת באופן מיידי
        לאחר השלמת תהליך הרכישה ואישור התשלום. עם השלמת הרכישה, הלקוח יקבל גישה מלאה
        למוצר/שירות דרך חשבונו האישי באתר או באפליקציה.
      </p>
      <p>
        במקרה של עיכוב טכני או בעיות בגישה למוצר, יש לפנות לשירות הלקוחות שלנו לצורך בדיקה
        וטיפול מהיר. האתר אינו אחראי לעיכובים או אי זמינות שנגרמים כתוצאה מבעיות טכניות
        חיצוניות שאינן בשליטתנו, כגון תקלות ברשת האינטרנט, השבתות או שביתות מצד צדדים
        שלישיים.
      </p>

      <h2>מדיניות ביטולים</h2>
      <p>
        1. האמור בסעיף זה כפוף לחוק הגנת הצרכן התשמ״א 1981 (להלן: "החוק").
      </p>
      <p>
        2. על המשתמש אשר מזמין את השירות היכולת לבטל את העסקה שביצע, הזיכוי יבוצע בכרטיס
        האשראי שבו בוצעה העסקה. הזיכוי יתבצע במקרים ובתנאים הבאים:
      </p>
      <p>
        ככל ולקוח יהיה מעוניין לבטל את ההזמנה של השירות או מוצר, ביטול ההזמנה יהיה כרוך
        בעמלת דמי טיפול של 5% או 100 ₪, הזול מבניהם בתוך 14 ימי עסקים מיום ההזמנה, זיכוי
        כספי יינתן עפ״י האמור בחוק.
      </p>
      <p>
        כאשר חלק מהשירות סופק ללקוח קרי קבלת אישורי הגעה דרך הפלטפורמה, דמי הביטול יהיו
        בגובה של השירות המסוים שסופק, ולא פחות מדמי הביטול הקבועים בחוק. בכל אופן, לא יינתן
        זיכוי כספי על תשלום לאחר 14 ימי עסקים ממועד ביצוע העסקה.
      </p>
      <p>
        תשלום עבור שירות הנעקת מתנה באשראי לא ניתן לזיכוי והתשלום לא יוחזר ללקוח בהתאם
        לחוק הגנת הצרכן.
      </p>
      <p>
        3. בירורים לגבי עסקאות וכן הודעה על ביטול עסקה יכולה להתבצע באחת משתי האפשרויות
        כדלקמן: במייל mariagefamily.il@gmail.com, בפניה מקוונת ב-WhatsApp למספר 054-2317742.
      </p>

      <h2>שינוי במדיניות הפרטיות</h2>
      <p>
        המפעילה של האתר שומרת על הזכות לבצע עדכונים במדיניות הפרטיות מתוך שיקול דעתה
        הבלעדי וללא כל הודעה מראש למשתמשים. שינויים אלו ייכנסו לתוקף תוך 48 שעות מרגע
        העדכון. המפעילה רשאית להודיע למשתמשים על כל שינוי במדיניות הפרטיות על פי שיקול
        דעתה. במקרה של שינויים מהותיים, היא תפרסם הודעה בעמוד הבית של האתר, וזאת 30 ימים
        לפני כניסתם לתוקף.
      </p>
      <p>
        המשך השימוש באתר מהווה את ההסכמה לנוסח המעודכן של מדיניות הפרטיות. אם המשתמש אינו
        מסכים עם הנוסח המעודכן, עליו להפסיק את השימוש באתר או באפליקציה.
      </p>
      <p>עדכון בתאריך 20.01.2025</p>
    </div>
  );
};

export default TermsOfUse;
